/*
 *
 * CreateDivisionModal constants
 *
 */

export const GET_DIVISIONS_NO_PARENTS_WATCHER =
  "app/CreateDivisionModal/GET_DIVISIONS_NO_PARENTS_WATCHER"
export const GET_DIVISIONS_NO_PARENTS_SUCCESS =
  "app/CreateDivisionModal/GET_DIVISIONS_NO_PARENTS_SUCCESS"

export const CREATE_DIVISION_WATCHER =
  "app/CreateDivisionModal/CREATE_DIVISION_WATCHER"
export const CREATE_DIVISION_SUCCESS =
  "app/CreateDivisionModal/CREATE_DIVISION_SUCCESS"
export const CREATE_DIVISION_FAILED =
  "app/CreateDivisionModal/CREATE_DIVISION_FAILED"
